const video = {
  state: {
    keyword: '',
    currentVideo: {}
  },
  mutations: {
    SET_VIDEO_SEARCH_KEYWORD: (state, keyword) => {
      state.keyword = keyword;
    },
    SET_CURRENT_VIDEO_ITEM: (state, item) => {
      state.currentVideo = item;
    }
  }
};

export default video;
